import { useSelector } from "react-redux";
import CarPlate from "../../components/carPlate/carPlate.component";
import { selectInstantReqResult } from "../../redux/instantReq/instantReq.selectors";
import { InstantReqPageSuccessStyled } from "./instantReqPageSuccess.styles";
import StarRatingComponent from "react-star-rating-component";
import { socketServer } from "../../assets/socketConnection";
import socket from "../../assets/socketConnection";
import { useState } from "react";
import { useHistory } from "react-router";
import LoadingPage from "../../components/loadingPage/loadingPage.component";

const InstantReqPageSuccess = () => {
  const history = useHistory();

  const instantReqResult = useSelector(selectInstantReqResult);

  const [submitIsLoading, setSubmitIsLoading] = useState(false);

  const isStatus0 = !instantReqResult?.status;
  //   if (instantReqResult) {
  //     const { driver, driver_distance } = instantReqResult;
  //   }

  socket.on("response_member_cancels_instant_request", ({ status }) => {
    setSubmitIsLoading(false);
    if (status == 1) {
      history.push("/reqs");
    }
  });
  socket.on("load_stream", (data) => {
    setSubmitIsLoading(false);
    console.log(data, "data22222222");
  });

  const onTataboghhClick = () => {
    socket.emit("member_request_next_driver_instant_request", {
      load_id: String(instantReqResult?.load?.[0]?._id),
    });
  };

  const onCancelClick = () => {
    setSubmitIsLoading(true);
    socket.emit("member_cancels_instant_request", {
      load_id: String(instantReqResult?.load?.[0]?._id),
    });
  };
  const onSubmitClick = () => {
    if (isStatus0) {
      let obj = {
        load_id: instantReqResult?.load?.[0]?._id,
        driver_id: instantReqResult?.driver?.[0]?._id,
      };

      console.log({ obj1111: obj });

      setSubmitIsLoading(true);
      socket.emit("set_driver_selected_instant", obj);
      return;
    }

    window.open(instantReqResult?.link_to_pay);
  };

  return (
    <InstantReqPageSuccessStyled>
      <LoadingPage isShow={submitIsLoading} />

      <div className="inner">
        <div className="inner__white">
          <div className="header d-flex">
            <div className="img">
              <img
                src={`${socketServer}uploaded_vehicle_images/${instantReqResult?.driver?.profile_img}.jpg`}
                alt=""
              />
            </div>
            <div className="mr-3">
              <div className="font-weight-bold" style={{ fontSize: "1.1em" }}>
                {instantReqResult?.driver?.[0]?.firstname + " "}
                {instantReqResult?.driver?.[0]?.lastname}
              </div>
              <div>
                <StarRatingComponent
                  name="show-rate"
                  editing={false}
                  // renderStarIcon={() => <span></span>}
                  starCount={5}
                  value={Math.round(instantReqResult?.driver?.[0]?.rank)}
                />
              </div>
            </div>
          </div>
          <div className="pelak mt-2 text-muted d-flex justify-content-between align-items-center">
            <div>مدل ماشین</div>
            <div>
              <CarPlate
                plate={
                  instantReqResult?.driver?.[0]?.drivervehicle?.national_plate
                }
              />
            </div>
          </div>
          <div className="distance text-center font-weight-bold py-1 mt-2">
            <span>فاصله تقریبی با شما: </span>
            <span>{instantReqResult?.load?.[0]?.estimate_km}</span>
          </div>
          <div>
            <div className="text-muted my-2">تصاویر خودرو</div>
            <div className="vehicle-images">
              {instantReqResult?.driver?.[0]?.drivervehicle?.vehicle_images
                .slice(0, 4)
                .map(({ _id, image }) => (
                  <div>
                    <img
                      src={`${socketServer}uploaded_vehicle_images/${image}.jpg`}
                      alt=""
                    />
                  </div>
                ))}
            </div>
          </div>
          {/* <div>
            <p>
              مبلغ ۱۸،۰۰۰۰ تومان از کیف پول شما به عنوان پیش پرداخت کسر می‌گردد
              که پس از حمل بار به راننده پرداخت می‌گردد.
            </p>
          </div> */}
          <div className="bottom-btns d-flex align-center mt-4">
            <button onClick={onTataboghhClick}>عدم تطابق خودرو</button>
            <button onClick={onSubmitClick}>
              {isStatus0 ? "انتخاب راننده" : "افزایش اعتبار"}
            </button>
          </div>
        </div>
        <div className="inner__bottom">
          <div>
            <button
              onClick={onCancelClick}
              className="bg-danger text-white border--4 p-1 my-2 w-100"
            >
              لغو درخواست
            </button>
          </div>
        </div>
      </div>
    </InstantReqPageSuccessStyled>
  );
};

export default InstantReqPageSuccess;
